module.exports = __webpack_public_path__ + "img/suspected-diagnosis-popup.c567c038.jpg";